import { IBrushType, PenEventName } from "../common/enums";
import { EventDispatcher } from "../common/event";
import NeoSmartpen from "./NeoSmartpen";
import RemotePen from "./RemotePen";
import VirtualPen from "./VirtualPen";
import WebViewPen from "./WebViewPen";
let _penmanager_instance = null;
let _active_pen = null;
export const DEFAULT_PEN_COLOR_NUM = 4;
export const DEFAULT_PEN_THICKNESS = 2;
export const DEFAULT_PEN_RENDERER_TYPE = IBrushType.PEN;
export default class PenManager {
    constructor() {
        this._pens = [];
        /** ID+MAC address to pen */
        this._mactoPenItem = {};
        /** @type {Array.<StorageRenderer>} */
        // render = [];
        this.getPens = () => {
            return this._pens;
        };
        this.pen_colors = [
            "rgb(169, 169, 169)",
            "rgb(255, 0, 0)",
            "rgb(255, 255, 2)",
            "rgb(0, 0, 128)",
            "rgb(0, 0, 0)",
            "rgb(255, 255, 255)",
            "rgb(255, 165, 0)",
            "rgb(0, 128, 0)",
            "rgb(0, 0, 255)",
            "rgb(128, 0, 128)",
            "rgb(169, 169, 169)" // 10 DARK_GARY #FFAAAAAA #A9A9A9
        ];
        this.marker_colors = [
            "rgb(217, 217, 224)",
            "rgb(232, 155, 162)",
            "rgb(244, 244, 175)",
            "rgb(166, 166, 212)",
            "rgb(167, 167, 174)",
            "rgb(255, 255, 255)",
            "rgb(241, 214, 171)",
            "rgb(166, 205, 173)",
            "rgb(167, 167, 251)",
            "rgb(205, 166, 212)",
            "rgb(217, 217, 224)" // 10
        ];
        this.color = this.pen_colors[DEFAULT_PEN_COLOR_NUM];
        this.thickness = DEFAULT_PEN_THICKNESS;
        this.penRendererType = DEFAULT_PEN_RENDERER_TYPE;
        this.calibrationPoint = { section: 0, owner: 0, book: 0, page: 0, x: 0, y: 0 };
        this.calibrationData = {
            section: 0, owner: 0, book: 0, page: 0, points: new Array(0),
        };
        this.dispatcher = new EventDispatcher();
        this.virtualPenSerial = 0;
        this.init = () => {
            this.setThickness(DEFAULT_PEN_THICKNESS);
            this.setPenRendererType(DEFAULT_PEN_RENDERER_TYPE);
            this.setColor(DEFAULT_PEN_COLOR_NUM);
        };
        this.getColorNum = (color) => {
            const index = this.pen_colors.findIndex((c) => c === color);
            return index;
        };
        /**
         *
         */
        this.addPenEvent = (pen) => {
            pen.addEventListener(PenEventName.ON_CONNECTED, this.onConnected);
            pen.addEventListener(PenEventName.ON_DISCONNECTED, this.onDisconnected);
            pen.addEventListener(PenEventName.ON_PEN_PAGEINFO, this.onLivePenPageInfo);
            pen.addEventListener(PenEventName.ON_SURFACE_OWNER_CHANGED, this.onSurfaceOwnerIdChanged);
            pen.addEventListener(PenEventName.ON_WRITER_CHANGED, this.onWriterIdChanged);
            pen.addEventListener(PenEventName.ON_PUI_COMMAND, this.onPuiCommand);
            // 2021/08/18
            pen.addEventListener(PenEventName.ON_PEN_STATUS_RESPONSE, this.onPenStatusResponse);
            pen.addEventListener(PenEventName.ON_PW_REQUIRED, this.onPasswordRequired);
        };
        this.removePenEvent = (pen) => {
            pen.removeEventListenerAll();
        };
        this.createPen = () => {
            const pen = new NeoSmartpen();
            this.addPenEvent(pen);
            return pen;
        };
        this.createWebViewPen = (mac) => {
            const pen = new WebViewPen(mac);
            this.addPenEvent(pen);
            return pen;
        };
        this.registerVirtualPen = (pen) => {
            this.addPenEvent(pen);
            // this.add(pen);  // connect에서 해 준다
            pen.connect();
            this.virtualPenSerial++;
            return pen;
        };
        this.createNetworkPen = (webBluetoothId, mac) => {
            const pen = new RemotePen(webBluetoothId, mac);
            this.addPenEvent(pen);
            // this.add(pen);  // connect에서 해 준다
            pen.connect();
            this.virtualPenSerial++;
            return pen;
        };
        this.getRegistedPen = (arg) => {
            const penUID = this.getPenUID(arg);
            return this._mactoPenItem[penUID];
        };
        this.getPenUID = (opt) => {
            return `${opt.webBluetoothId}_${opt.inputType.type}_${opt.inputType.local}_${opt.mac}`;
        };
        this.getNetworkPen = (webBluetoothId, mac) => {
            const penUID = this.getPenUID({
                webBluetoothId: webBluetoothId,
                mac,
                inputType: RemotePen.getInputType(),
            });
            let pen = this._mactoPenItem[penUID];
            if (!pen) {
                pen = this.createNetworkPen(webBluetoothId, mac);
            }
            return pen;
        };
        this.getVirtualPen = () => {
            const { mac, webBluetoothId } = VirtualPen.generateVirualPenMacAndId();
            const penUID = this.getPenUID({
                webBluetoothId: webBluetoothId,
                mac: mac,
                inputType: VirtualPen.getInputType(),
            });
            let found = this._mactoPenItem[penUID];
            if (!found) {
                const pen = new VirtualPen();
                found = pen;
                this.registerVirtualPen(pen);
            }
            return found;
            // if (!this._virtualPen) {
            //   this._virtualPen = this.createVirtualPen();
            // }
            // return this._virtualPen;
        };
        this.onLivePenPageInfo = (event) => {
            this.dispatcher.dispatch(PenEventName.ON_PEN_PAGEINFO, event);
        };
        /**
         *
         * @param pen
         * @param device
         */
        this.add = (pen) => {
            let newlyAdded = false;
            // console.log(`Pen Added, ${pen.webBluetoothId}`);
            const penUID = this.getPenUID({
                webBluetoothId: pen.webBluetoothId,
                mac: pen.mac,
                inputType: pen.inputType,
            });
            const found = this._mactoPenItem[penUID];
            if (!found) {
                this._pens.push(pen);
                this._mactoPenItem[penUID] = pen;
                newlyAdded = true;
            }
            // console.log(`PenManager: pen added, mac=${pen.mac}`);
            return { pen, newlyAdded };
        };
        /**
         *
         * @param device
         */
        this.isBtPenAlreadyConnected = (device) => {
            const index = this._pens.findIndex(pen => {
                const idMatched = (pen.webBluetoothId === device.id);
                return idMatched;
            });
            if (index > -1)
                return true;
            return false;
        };
        /**
         *
         * @param pen
         */
        this.removePen = (pen) => {
            const penUID = this.getPenUID({
                webBluetoothId: pen.webBluetoothId,
                mac: pen.mac,
                inputType: pen.inputType,
            });
            const found = this._mactoPenItem[penUID];
            if (found) {
                this.removePenEvent(found);
            }
            // const index = this._pens.findIndex(p => p.mac === pen.mac);
            const index = this._pens.findIndex(p => p === found);
            if (index > -1) {
                // const pen = this._pens[index];
                this._pens.splice(index, 1);
                delete this._mactoPenItem[penUID];
                return true;
            }
            return false;
        };
        this.setActivePen = (mac) => {
            const pen = this._pens.find(p => p.mac === mac);
            if (pen) {
                _active_pen = pen;
            }
        };
        this.setColor = (color_num) => {
            // this.toggleColorRadioButton(color_num);
            this.color = this.pen_colors[color_num];
            if (_active_pen) {
                _active_pen.setColor(this.color);
            }
            this.dispatcher.dispatch(PenEventName.ON_COLOR_CHANGED, this);
        };
        // toggleColorRadioButton(color_num: number) {
        //   const $elem = $(`.color_${color_num}`);
        //   this.toggleColorRadioButton_inner(undefined, $elem);
        // }
        // toggleColorRadioButton_inner(e, $elem) {
        //   if ($elem === undefined) {
        //     $elem = $(e.target);
        //   }
        //   if ($elem.hasClass("color_icon")) {
        //     $(".color_icon").each(function () {
        //       $(this).removeClass("pressed");
        //     });
        //     $elem.addClass("pressed");
        //   }
        // }
        this.setPenRendererType = (type) => {
            // const $elem = $("#btn_brush").find(".c2");
            // this.setPenTypeStatus($elem, type);
            // if (type === IBrushType.MARKER) {
            //   for (let i = 0; i < 11; i++) {
            //     $('#clr_' + [i]).find(".color_" + [i]).css('background-color', this.marker_colors[i]);
            //   }
            // }
            // else if (type === IBrushType.PEN) {
            //   for (let i = 0; i < 11; i++) {
            //     $('#clr_' + [i]).find(".color_" + [i]).css('background-color', this.pen_colors[i]);
            //   }
            // }
            this.penRendererType = type;
            if (_active_pen) {
                _active_pen.setPenRendererType(this.penRendererType);
                _active_pen.setColor(this.color);
            }
        };
        // setPenTypeStatus($elem, type) {
        //   if (type === IBrushType.MARKER) {
        //     $elem.removeClass("state_0");
        //     $elem.removeClass("state_2");
        //     $elem.addClass("state_1");
        //   } else if (type === IBrushType.ERASER) {
        //     $elem.removeClass("state_0");
        //     $elem.removeClass("state_1");
        //     $elem.addClass("state_2");
        //   } else if (type === IBrushType.PEN) {
        //     $elem.removeClass("state_1");
        //     $elem.removeClass("state_2");
        //     $elem.addClass("state_0");
        //   }
        // }
        this.setThickness = (thickness) => {
            // $("#thickness_num").text(thickness);
            thickness = thickness / 10;
            this.thickness = thickness;
            if (_active_pen) {
                _active_pen.setThickness(this.thickness);
            }
        };
        /**
         *
         *
         * @param {IPenToViewerEvent} event
         * @memberof PenManager
         */
        this.onConnected = (event) => {
            const { pen } = event;
            pen.connected = true;
            this.add(pen);
            this.dispatcher.dispatch(PenEventName.ON_CONNECTED, event);
        };
        /**
         *
         *
         * @param {IPenToViewerEvent} event - {pen: INeoSmartpen, mac: string, event: IPenCommEvent}
         * @memberof PenManager
         */
        this.onDisconnected = (event) => {
            const { pen } = event;
            if (this.removePen(pen)) {
                // 연결된 상위 listener에 전달
                this.dispatcher.dispatch(PenEventName.ON_DISCONNECTED, event);
            }
            else {
                console.log("PenManager: something wrong, un-added pen disconnected");
            }
            // $("#pen_id").text(`${this.penArray.length}`);
            // if (this.penArray.length === 0) {
            //   const $elem = $("#btn_connect").find(".c2");
            //   $elem.removeClass("checked");
            // }
        };
        /**
         *
         * @param opt
         */
        this.onNcodeError = (opt) => {
            // const { pen, event } = opt;
        };
        /**
         * 2021/06/13
         *
         * @param {IPenToViewerEvent} e
         * @memberof PenManager
         */
        this.onSurfaceOwnerIdChanged = (e) => {
            this.dispatcher.dispatch(PenEventName.ON_SURFACE_OWNER_CHANGED, e);
        };
        /**
         * 2021/06/13
         *
         * @param {IPenToViewerEvent} e
         * @memberof PenManager
         */
        this.onWriterIdChanged = (e) => {
            this.dispatcher.dispatch(PenEventName.ON_WRITER_CHANGED, e);
        };
        /**
         * 2021/07/05
         *
         * @param {IPenToViewerEvent} e
         * @memberof PenManager
         */
        this.onPuiCommand = (e) => {
            this.dispatcher.dispatch(PenEventName.ON_PUI_COMMAND, e);
        };
        /**
         * 2021/08/18
         * @param event
         */
        this.onPenStatusResponse = (event) => {
            // const status = event.event.status;
            this.dispatcher.dispatch(PenEventName.ON_PEN_STATUS_RESPONSE, event);
        };
        /**
         * 2021/08/18
         * @param event
         */
        this.onPasswordRequired = (event) => {
            if (!this.dispatcher.hasListener(PenEventName.ON_PW_REQUIRED)) {
                const pen = event.pen;
                const passcodeStatus = event.event.passcodeStatus;
                // const passcode = prompt(`Please enter the passcode (CAUTION! After ${passcodeStatus.retryLimit - passcodeStatus.retryCount} times failed, the pen data will be erased)`);
                const passcode = prompt(`비밀번호를 입력하세요. (펜 비밀번호를 ${passcodeStatus.retryLimit - passcodeStatus.retryCount}회 잘못 입력하시면, 펜의 필기 데이터가 초기화 됩니다.)`);
                if (!passcode)
                    return;
                pen.sendPasscode(passcode);
            }
            else {
                this.dispatcher.dispatch(PenEventName.ON_PW_REQUIRED, event);
            }
        };
        /**
         * 2021/08/18
         *
         * 패스워드 처리 custom UI의 절차
         * 1) PenEventName.ON_PW_REQUIRED 의 이벤트를 받아서
         * 2) password를 입력 받고
         * 3) PenManager.getInstance().sendPasscode( event.pen, passcode )
         *
         * @param pen
         * @param passcode
         */
        this.sendPasscode = (pen, passcode) => {
            pen.sendPasscode(passcode);
        };
        /**
         *
         */
        this.getConnectedPens = () => {
            const connected = this._pens.filter(pen => pen.connected);
            return connected;
        };
        this.setCalibrationMode = (mode) => {
            this._inCalibration = mode;
        };
        this.addEventListener = (eventName, listener) => {
            this.dispatcher.on(eventName, listener, null);
        };
        /**
         *
         * @param eventName
         * @param listener
         */
        this.removeEventListener = (eventName, listener) => {
            this.dispatcher.off(eventName, listener);
        };
        if (_penmanager_instance)
            return _penmanager_instance;
    }
    static getInstance() {
        if (_penmanager_instance)
            return _penmanager_instance;
        _penmanager_instance = new PenManager();
        return _penmanager_instance;
    }
    get isCalibrationMode() {
        return this._inCalibration;
    }
}
//# sourceMappingURL=PenManager.js.map